import CatalogRelease from '@common/types/catalog/catalog-release';

export const calculateTimeLeft = (
  item: CatalogRelease
): {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
} => {
  // let year = new Date().getFullYear();
  let difference = 0;
  if (item.takedownTime)
    difference = +new Date(item?.takedownTime) - +new Date();

  let timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };

  if (difference > 0) {
    timeLeft = {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }

  return timeLeft;
};
